import axios from 'axios';
import APIS from '../../apis';
import APIS_MEMBER from '../../apis/member';
import qs from 'qs';
import  {callbackHandler} from '../callbackHandler';

export default {
  state: {

  },
  mutations: {

  },
  getters: {},
  actions: {
    //获取会员分销卡地址
    get360DistributionCard(context, params) {
      return axios.get(APIS.get360DistributionCard, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.get360DistributionCard, res);
        return res.data;
      })
    },
    // distributionRankingList
    distributionRankingList(context, params) {
      return axios.get(APIS.distributionRankingList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.distributionRankingList, res);
        return res.data;
      })
    },
    get525Qrcode(context, params) {
      return axios.get(APIS.get525Qrcode, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.get525Qrcode, res);
        return res.data;
      })
    },
    //亲友卡我的邀请记录
    friendCardMyInvite(context, params){
      return new Promise((resolve, reject) => {
        axios.get(APIS_MEMBER.friendCardMyInvite, {
          params: params.params
        }).then(function (res) {
          callbackHandler(APIS_MEMBER.friendCardMyInvite, res);
          if (res.data.code == 1) {
            resolve(res.data)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    //亲友卡领取接口
    friendReceive(context, {env, params}={}){
        return axios.post(APIS_MEMBER.friendReceive, qs.stringify(params)).then((res)=>{
            return callbackHandler(APIS_MEMBER.friendReceive, res);
            return res.data;
        })
    },
    //亲友卡排行榜
    friendCardRank(context, params){
      return axios.get(APIS_MEMBER.friendCardRank, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS_MEMBER.friendCardRank, res);
        return res.data;
      })
    },
    //绑定此刻心理手机号
    consultBindPhone(context, {env, params}={}){
        return axios.post(APIS_MEMBER.consultBindPhone, qs.stringify(params)).then((res)=>{
            return callbackHandler(APIS_MEMBER.consultBindPhone, res);
            return res.data;
        })
    },
    //亲友卡我的邀请记录-是否绑定手机号
    phoneStatusAndAutoBind(context, params){
      return axios.get(APIS_MEMBER.phoneStatusAndAutoBind, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS_MEMBER.phoneStatusAndAutoBind, res);
        return res.data;
      })
    },
    //亲友卡领取状态接口
    friendCardReceiveStatus(context, params){
      return axios.get(APIS_MEMBER.friendCardReceiveStatus, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS_MEMBER.friendCardReceiveStatus, res);
        return res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/member.js